<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'universalinvoiceIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'universalinvoice',
				windowName: '通用开票',
				// windowType: 'modal',
				windowType: 'window',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {
			
		}
	}
</script>
